export default {
      id: "app-store-download-usage",
      viewBox: "0 0 147 43",
      url: __webpack_public_path__ + "sprite.svg#app-store-download",
      toString: function () {
        return this.url;
      }
    }